import { namedRoutes } from '../../modules/named-router'
import React from 'react'
import Topics from '../../topics'
import Router from '../Router'

const Routes = (props) => <Router customRoutes={namedRoutes} Topics={Topics} {...props} />

export default Routes
